import React from "react";
import Card from "./Card"; 
import { updateLocalStat, unlockCard, trackStat } from "../pages/HostGame";

// ==========================================
// FAMILIEN KONFIGURATION (Icons & Farben)
// ==========================================
const FAMILY_INFO = {
  "Aristocrat": { icon: "💰", color: "#FFD700", title: "Tier 3: 10% Shop Discount\nTier 5: 25% Shop Discount" },
  "Survivor": { icon: "🛡️", color: "#4CAF50", title: "Tier 3: -1 All Damage\nTier 5: 10 HP Shield per Round" },
  "Trickster": { icon: "🃏", color: "#FF4500", title: "Tier 3: 15% Dodge Chance\nTier 5: Double Poker/Gamble Luck" },
  "Illusionist": { icon: "🌈", color: "#9C27B0", title: "Tier 3: +2 Gold on Black Cards\nTier 5: Ignore Colors completely" },
  "Aggressor": { icon: "⚔️", color: "#F44336", title: "Tier 3: Heal 1 HP on Attack\nTier 5: Execute Enemies under 5 HP" },
  "Architect": { icon: "🌀", color: "#2196F3", title: "Tier 3: Scry on Draw\nTier 5: Recycle Hand Cards" },
  "Neutral": { icon: "🕵️", color: "#9E9E9E", title: "No Set Bonuses" }
};

export default function Shop({
  socket, 
  roomCode, 
  gamePhase, 
  playersReady, 
  myPlayer, 
  myPlayerIndex, 
  currentRound, 
  players
}) {
  const [showDeck, setShowDeck] = React.useState(false);
  const [selectedFamily, setSelectedFamily] = React.useState(null);
  
  if (gamePhase !== "shop") return null;

  const amIReady = playersReady.includes(myPlayer?.id);
  const removeCost = Math.pow(2, myPlayer?.removedCardsCount || 0); 
  const canRemoveCards = myPlayer?.deck.length > 8;

  if (!myPlayer) {
    return <div style={{color: "white", textAlign: "center", marginTop: 50}}>Loading Shop... 🛒</div>;
  }

  const hasOpenPackage = myPlayer.openedPackageType != null;
  const packageOptions = myPlayer.currentPackageOptions || [];

  

  // ==========================================
  // ZÄHLT DIE AKTIVEN FAMILIEN DES SPIELERS
  // ==========================================
  const familyCounts = {};
  if (myPlayer.activeEffects) {
    myPlayer.activeEffects.forEach(eff => {
      if (eff.family) {
        familyCounts[eff.family] = (familyCounts[eff.family] || 0) + 1;
      }
    });
  }

  // ==========================================
  // HILFSFUNKTION FÜR DIE MINI-KARTEN-ILLUSION
  // ==========================================
  const renderMiniCards = (type) => {
    let dummyCards = [];
    if (type === "standard") {
      dummyCards = [{ type: "number", color: "blue", value: 3, id: "d1" }, { type: "number", color: "green", value: 7, id: "d2" }, { type: "number", color: "red", value: 5, id: "d3" }];
    } else if (type === "special") {
      dummyCards = [{ type: "special", name: "Amnesie", color: "special", id: "d4" }, { type: "special", name: "Kettenreaktion", color: "special", id: "d5" }, { type: "special", name: "Schwarzes Loch", color: "special", id: "d6" }];
    } else if (type === "effect") {
      dummyCards = [{ type: "effect", name: "Spion", color: "effect", id: "d7" }, { type: "effect", name: "Armor", color: "effect", id: "d8" }, { type: "effect", name: "Bombe", color: "effect", id: "d9" }];
    } else if (type === "remove") {
      dummyCards = [{ type: "number", color: "yellow", value: 1, id: "d10" }, { type: "number", color: "blue", value: 9, id: "d11" }, { type: "number", color: "red", value: 0, id: "d12" }];
    }

    return (
      <div style={{ position: "relative", width: 120, height: 110, margin: "20px auto", filter: type === "remove" ? "grayscale(80%) sepia(50%) hue-rotate(-50deg) brightness(0.6)" : "none" }}>
        <div style={{ position: "absolute", top: 20, left: 0, transform: "rotate(-15deg)", zIndex: 1, pointerEvents: "none" }}><Card card={dummyCards[0]} disabled={true} width={55} height={80} /></div>
        <div style={{ position: "absolute", top: 20, right: 0, transform: "rotate(15deg)", zIndex: 1, pointerEvents: "none" }}><Card card={dummyCards[1]} disabled={true} width={55} height={80} /></div>
        <div style={{ position: "absolute", top: 5, left: 32, transform: "scale(1.1)", zIndex: 2, boxShadow: "0 0 15px rgba(0,0,0,0.8)", pointerEvents: "none" }}><Card card={dummyCards[2]} disabled={true} width={55} height={80} /></div>
        {type === "remove" && <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 3, fontSize: "3em", filter: "drop-shadow(0 0 10px red)" }}>🔥</div>}
      </div>
    );
  };

  const getPackStyle = (type) => {
    switch(type) {
      case "special": return { color: "#ff00ff", title: "Special Card Pack" };
      case "effect": return { color: "#ff8800", title: "Effect Card Pack" };
      case "remove": return { color: "#888", title: "Delete a Card" };
      case "standard": default: return { color: "white", title: "Standard Card Pack" };
    }
  };
  const packStyle = hasOpenPackage ? getPackStyle(myPlayer.openedPackageType) : {};

  return (
    <div style={{ 
      padding: "40px 40px 120px 40px", // Extra padding unten wegen des fixierten Footers
      color: "white", minHeight: "100vh", fontFamily: "sans-serif",
      backgroundImage: "url('/background.png')", backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed",
      display: "flex", flexDirection: "column", alignItems: "center", position: "relative"
    }}>
      
      <style>{`
        button { transition: transform 0.1s ease-in-out, filter 0.1s ease-in-out, box-shadow 0.1s ease-in-out; }
        button:not(:disabled):hover { transform: scale(1.05); filter: brightness(1.2); }
        button:disabled { opacity: 0.5; cursor: not-allowed !important; transform: none !important; filter: none !important; }
      `}</style>

      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: 40, width: "100%", position: "relative", zIndex: 10 }}>
        <button 
          onClick={() => setShowDeck(true)}
          style={{ position: "absolute", top: 0, right: 20, padding: "8px 15px", backgroundColor: "#333", color: "white", borderRadius: 8, cursor: "pointer", border: "1px solid #555", fontWeight: "bold" }}
        >
          🔍 My Deck ({myPlayer.deck.length})
        </button>

        <h1 style={{ fontSize: "3.5em", margin: "0 0 10px 0", textShadow: "0 4px 10px rgba(0,0,0,0.8)" }}>
          {hasOpenPackage ? "Choose a Card!" : "Welcome to the Shop!"}
        </h1>
        <p style={{ color: "#aaa", fontSize: "1.2em", margin: 0, fontWeight: "bold" }}>
          Round {currentRound - 1} | Gold: {myPlayer.gold} | HP: {myPlayer.hp} | Deck: {myPlayer.deck.length}
        </p>
      </div>

      {/* DECK OVERLAY */}
      {showDeck && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.95)", zIndex: 1000, padding: 50, overflowY: "auto" }}>
            <button onClick={() => setShowDeck(false)} style={{ position: "fixed", top: 20, right: 20, padding: "10px 20px", fontSize: "1.2em", cursor: "pointer", backgroundColor: "darkred", color: "white", border: "2px solid white", borderRadius: 8, fontWeight: "bold" }}>❌ Close</button>
            <h2 style={{ color: "gold", textAlign: "center", fontSize: "2em" }}>Your current Deck</h2>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center", marginTop: 40 }}>
            {myPlayer.deck.map((card, i) => {
                if (!card) return null; 
                return <Card key={card.id || i} card={card} disabled={true} />;
            })}
            </div>
        </div>
      )}

      {/* SHOP BEREICH */}
      <div style={{ width: "100%", maxWidth: "1000px", display: "flex", flexDirection: "column", alignItems: "center", zIndex: 10 }}>
        
        {!hasOpenPackage ? (
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap", justifyContent: "center", width: "100%" }}>
            
            <button 
              disabled={myPlayer.gold < 5 || amIReady}
              onClick={() => socket.emit("open_package", { roomCode, playerIndex: myPlayerIndex, packageType: "standard" })} 
              style={{ backgroundColor: "rgba(20,20,20,0.8)", border: "2px solid white", borderRadius: 15, padding: "20px", width: 220, display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", backdropFilter: "blur(5px)" }}
            >
              <h2 style={{ margin: "0 0 10px 0", color: "white" }}>Standard</h2>
              {renderMiniCards("standard")}
              <div style={{ width: "80%", backgroundColor: "gold", color: "black", padding: "10px", borderRadius: 8, fontWeight: "bold", fontSize: "1.2em", marginTop: "10px" }}>5 Gold</div>
            </button>
            
            <button 
              disabled={myPlayer.gold < 10 || amIReady}
              onClick={() => socket.emit("open_package", { roomCode, playerIndex: myPlayerIndex, packageType: "special" })} 
              style={{ backgroundColor: "rgba(20,20,20,0.8)", border: "2px solid #ff00ff", borderRadius: 15, padding: "20px", width: 220, display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", backdropFilter: "blur(5px)" }}
            >
              <h2 style={{ margin: "0 0 10px 0", color: "white" }}>Special</h2>
              {renderMiniCards("special")}
              <div style={{ width: "80%", backgroundColor: "gold", color: "black", padding: "10px", borderRadius: 8, fontWeight: "bold", fontSize: "1.2em", marginTop: "10px" }}>10 Gold</div>
            </button>

            <button 
              disabled={myPlayer.gold < 15 || amIReady}
              onClick={() => socket.emit("open_package", { roomCode, playerIndex: myPlayerIndex, packageType: "effect" })} 
              style={{ backgroundColor: "rgba(20,20,20,0.8)", border: "2px solid #ff8800", borderRadius: 15, padding: "20px", width: 220, display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", backdropFilter: "blur(5px)" }}
            >
              <h2 style={{ margin: "0 0 10px 0", color: "white" }}>Effect</h2>
              {renderMiniCards("effect")}
              <div style={{ width: "80%", backgroundColor: "gold", color: "black", padding: "10px", borderRadius: 8, fontWeight: "bold", fontSize: "1.2em", marginTop: "10px" }}>15 Gold</div>
            </button>

            <button 
              disabled={myPlayer.gold < removeCost || amIReady || !canRemoveCards}
              onClick={() => socket.emit("open_package", { roomCode, playerIndex: myPlayerIndex, packageType: "remove" })} 
              style={{ backgroundColor: "rgba(20,20,20,0.8)", border: "2px solid #666", borderRadius: 15, padding: "20px", width: 220, display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", backdropFilter: "blur(5px)" }}
            >
              <h2 style={{ margin: "0 0 10px 0", color: "white" }}>Delete</h2>
              {renderMiniCards("remove")}
              <div style={{ width: "80%", backgroundColor: "gold", color: "black", padding: "10px", borderRadius: 8, fontWeight: "bold", fontSize: "1.2em", marginTop: "10px" }}>{removeCost} Gold</div>
              {!canRemoveCards && <div style={{color: "red", fontSize: "0.8em", marginTop: 5, fontWeight: "bold"}}>Deck zu klein!</div>}
            </button>
          </div>

        ) : (
          <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
            
            <div style={{ 
              backgroundColor: "rgba(30, 30, 30, 0.7)", border: `4px solid ${packStyle.color}`, 
              borderRadius: 20, padding: "30px", width: "100%", maxWidth: "900px", display: "flex", 
              flexDirection: "column", alignItems: "center", backdropFilter: "blur(10px)", marginBottom: "30px" 
            }}>
              
              <h2 style={{ color: "white", fontSize: "2.2em", margin: "0 0 40px 0" }}>{packStyle.title}</h2>

              <div style={{ display: "flex", gap: 30, justifyContent: "center", flexWrap: "wrap" }}>
                {packageOptions.map((item, index) => {
                  if (!item) return null; 
                  const familyInfo = item.family ? FAMILY_INFO[item.family] : null;

                  return (
                  <div key={item.id || index} style={{ width: "160px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", opacity: amIReady ? 0.5 : 1 }}>
                    
                    <Card 
                    card={item} 
                    disabled={amIReady}
                    onClick={() => {
                        trackStat("upgradesBought", 1);
                        if (item.name) unlockCard(item);
                        socket.emit("pick_package_option", { roomCode, playerIndex: myPlayerIndex, selectedCard: item });
                    }}
                    />
                    
                    <div style={{ 
                      marginTop: "15px", backgroundColor: "rgba(20, 20, 20, 0.8)", padding: "10px", 
                      borderRadius: "10px", border: "2px solid #444", width: "100%", minHeight: "100px", 
                      display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" 
                    }}>
                      
                      {familyInfo && (
                        <div style={{
                          backgroundColor: "rgba(0,0,0,0.5)", border: `1px solid ${familyInfo.color}`,
                          color: "white", padding: "2px 6px", borderRadius: "8px", fontSize: "0.7em",
                          marginBottom: "8px", display: "flex", alignItems: "center", gap: "4px"
                        }}>
                          <span>{familyInfo.icon}</span> <span>{item.family}</span>
                        </div>
                      )}

                      <b style={{ color: packStyle.color, display: "block", marginBottom: "5px", textTransform: 'capitalize', fontSize: "1em" }}>
                        {item.name || `${item.color} ${item.value}`}
                      </b>
                      {item.description && (
                        <span style={{ fontSize: "0.75em", color: "#aaa", display: "block", lineHeight: "1.2" }}>{item.description}</span>
                      )}
                    </div>
                  </div>
                )})}
              </div>
            </div>

            <button 
              onClick={() => socket.emit("cancel_package", { roomCode, playerIndex: myPlayerIndex })} 
              style={{ padding: "15px 60px", fontSize: "1.5em", backgroundColor: "#333", color: "white", fontWeight: "bold", border: "none", borderRadius: 15, cursor: "pointer", boxShadow: "0 5px 15px rgba(0,0,0,0.5)" }}
            >
              Cancel
            </button>

          </div>
        )}

        {!hasOpenPackage && (
          <div style={{ marginTop: 60 }}>
            {!amIReady ? (
              <button 
                onClick={() => socket.emit("shop_ready", { roomCode, playerIndex: myPlayerIndex })}
                style={{ padding: "15px 50px", fontSize: "1.5em", backgroundColor: "#333", color: "white", fontWeight: "bold", border: "none", borderRadius: 15, cursor: "pointer", boxShadow: "0 5px 15px rgba(0,0,0,0.5)" }}
              >
                Ready {playersReady.length}/{players.length}
              </button>
            ) : (
              <button 
                disabled={true}
                style={{ padding: "15px 50px", fontSize: "1.5em", backgroundColor: "#111", color: "green", fontWeight: "bold", border: "2px solid green", borderRadius: 15 }}
              >
                Waiting {playersReady.length}/{players.length}...
              </button>
            )}
          </div>
        )}

      </div>

      {/* ========================================= */}
      {/* SYNERGY DOCK (Horizontaler Footer)          */}
      {/* ========================================= */}
      <div style={{
        position: "fixed", bottom: 0, left: 0, width: "100%",
        backgroundColor: "rgba(10, 10, 10, 0.95)", borderTop: "2px solid #333",
        padding: "15px 0", display: "flex", justifyContent: "center", gap: "30px",
        backdropFilter: "blur(10px)", zIndex: 100, flexWrap: "wrap",
        boxShadow: "0 -5px 20px rgba(0,0,0,0.5)"
      }}>
        {Object.keys(FAMILY_INFO).map(family => {
          if (family === "Neutral") return null; 
          
          const count = familyCounts[family] || 0;
          const info = FAMILY_INFO[family];
          
          const isActive = count > 0;
          const isTier1 = count >= 3;
          const isTier2 = count >= 5;

          return (
            <div 
              key={family} 
              onClick={() => setSelectedFamily(family)}
              style={{ 
                display: "flex", flexDirection: "column", alignItems: "center", gap: "6px",
                opacity: isActive ? 1 : 0.3, transition: "opacity 0.2s, transform 0.2s",
                transform: isTier1 ? "scale(1.05)" : "scale(1)", cursor: "pointer"
            }}>
              
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <span style={{ fontSize: "1.3em", filter: isTier1 ? `drop-shadow(0 0 5px ${info.color})` : "none" }}>{info.icon}</span>
                <span style={{ fontSize: "0.9em", fontWeight: isActive ? "bold" : "normal", color: isActive ? "white" : "#aaa", textTransform: "uppercase", letterSpacing: "1px" }}>{family}</span>
              </div>
              
              {/* TFT-Style Fortschritts-Striche */}
              <div style={{ display: "flex", gap: "4px" }}>
                {[1,2,3,4,5].map(num => (
                  <div key={num} style={{
                    width: "12px", height: "4px", borderRadius: "2px",
                    backgroundColor: count >= num ? info.color : "#222",
                    boxShadow: count >= num ? `0 0 5px ${info.color}` : "none",
                    border: (num === 3 || num === 5) && count < num ? "1px solid #555" : "none" 
                  }} />
                ))}
              </div>

            </div>
          );
        })}
      </div>

      {/* 📊 OVERLAY: SYNERGY PROGRESSION */}
      {selectedFamily && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.9)", backdropFilter: "blur(10px)", zIndex: 10000, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", animation: "fadeIn 0.2s ease-out" }}>
          
          <div style={{ backgroundColor: "rgba(20,20,20,0.95)", border: `3px solid ${FAMILY_INFO[selectedFamily].color}`, borderRadius: "20px", padding: "40px", maxWidth: "400px", width: "90%", textAlign: "center", position: "relative", boxShadow: `0 0 40px ${FAMILY_INFO[selectedFamily].color}44` }}>
            <button onClick={() => setSelectedFamily(null)} style={{ position: "absolute", top: "15px", right: "20px", background: "none", border: "none", color: "white", fontSize: "1.5em", cursor: "pointer" }}>✖</button>
            
            <div style={{ fontSize: "4em", filter: `drop-shadow(0 0 10px ${FAMILY_INFO[selectedFamily].color})`, marginBottom: "10px" }}>
              {FAMILY_INFO[selectedFamily].icon}
            </div>
            
            <h2 style={{ color: "white", textTransform: "uppercase", letterSpacing: "2px", margin: "0 0 30px 0" }}>{selectedFamily}</h2>

            <div style={{ display: "flex", flexDirection: "column", gap: "20px", textAlign: "left" }}>
              {/* TIER 1 (3 Karten) */}
              <div style={{ padding: "15px", backgroundColor: (familyCounts[selectedFamily] || 0) >= 3 ? `${FAMILY_INFO[selectedFamily].color}33` : "rgba(0,0,0,0.5)", border: `2px solid ${(familyCounts[selectedFamily] || 0) >= 3 ? FAMILY_INFO[selectedFamily].color : "#444"}`, borderRadius: "12px", transition: "all 0.3s" }}>
                <h4 style={{ margin: "0 0 5px 0", color: (familyCounts[selectedFamily] || 0) >= 3 ? "white" : "#888" }}>Tier 1 (3 Cards)</h4>
                <p style={{ margin: 0, fontSize: "0.95em", color: (familyCounts[selectedFamily] || 0) >= 3 ? "#ddd" : "#666" }}>
                  {FAMILY_INFO[selectedFamily].title.split("Tier 5:")[0].replace("Tier 3:", "").trim()}
                </p>
              </div>

              {/* TIER 2 (5 Karten) */}
              <div style={{ padding: "15px", backgroundColor: (familyCounts[selectedFamily] || 0) >= 5 ? `${FAMILY_INFO[selectedFamily].color}33` : "rgba(0,0,0,0.5)", border: `2px solid ${(familyCounts[selectedFamily] || 0) >= 5 ? FAMILY_INFO[selectedFamily].color : "#444"}`, borderRadius: "12px", transition: "all 0.3s" }}>
                <h4 style={{ margin: "0 0 5px 0", color: (familyCounts[selectedFamily] || 0) >= 5 ? "white" : "#888" }}>Tier 2 (5 Cards)</h4>
                <p style={{ margin: 0, fontSize: "0.95em", color: (familyCounts[selectedFamily] || 0) >= 5 ? "#ddd" : "#666" }}>
                  {FAMILY_INFO[selectedFamily].title.split("Tier 5:")[1]?.trim()}
                </p>
              </div>
            </div>

            <div style={{ marginTop: "30px", color: "gray", fontSize: "0.9em" }}>
              You currently have <strong style={{ color: FAMILY_INFO[selectedFamily].color, fontSize: "1.2em" }}>{familyCounts[selectedFamily] || 0}</strong> {selectedFamily} cards.
            </div>

          </div>
        </div>
      )}

    </div>
  );
}